/**
 * AA FAQ Accordion Logic
 * Sorgt dafür, dass nur ein FAQ-Eintrag gleichzeitig geöffnet sein kann.
 */
const initFaqAccordion = () => {
  document.addEventListener('click', (event) => {
    // Prüfen, ob der Klick auf einem Summary-Element eines FAQ-Blocks landete
    const summary = event.target.closest('.aa-js-accordion summary');
    if (!summary) return;

    const currentDetails = summary.parentElement;

    // Wenn das Element gerade geschlossen ist und jetzt geöffnet wird
    if (!currentDetails.hasAttribute('open')) {
      // Suche alle anderen FAQ-Elemente auf der gesamten Seite
      const allAccordions = document.querySelectorAll('.aa-js-accordion');
      
      allAccordions.forEach((details) => {
        if (details !== currentDetails && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
    }
  });
};

// Initialisierung beim Laden der Seite
document.addEventListener('DOMContentLoaded', initFaqAccordion);

// Optional: Re-Initialisierung für den Shopify Theme Editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFaqAccordion);
}